<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theSelectProjectId' v-if="theUserProject==0" clearable size="small" @change="theSelectProjectChange" placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-input
          v-model="getSysRuleIncomeList_data.businessName"
          placeholder="请输入业务名称"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getSysRuleIncomeList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if="addSysRuleIncome && theSelectProjectId"
          @click="toAddSysRuleIncome"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加收益规则
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getSysRuleIncomeList'
      api='getSysRuleIncomeList'
      xupdateapi='updateSysRuleIncome'
      :height="H-165" >
    </mytable>

    <myform
      :viewobj='{
        addSysRuleIncome:    [ "新增收益规则信息", "el-icon-circle-plus" ],
        updateSysRuleIncome: [ "修改收益规则信息", "el-icon-edit-outline"],
        $succeed$: getSysRuleIncomeList
      }'
      @close='$form("addSysRuleIncome","reset")'
      @opened="$form('addSysRuleIncome','ifshow') && (Myformdata.sriMold=1),
      Myformdata.projectId=theSelectProjectId" >
      <hide slot='sriId' />
      <hide slot='projectId' />
      <template v-slot:projectId="{Myformdata}" >
        <el-select v-model='Myformdata.projectId' disabled @change="projectChange">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:sriType="{Myformdata}" >
        <el-select v-model='Myformdata.sriType' @change="sriTypeChange">
            <el-option
                v-for="item in theSriTypeAll"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:sriMold="{Myformdata}" >
        <el-select v-model='Myformdata.sriMold' @change="sriMoldChange" :disabled="Myformdata.sriType==3 ||Myformdata.sriType == 8 || Myformdata.sriType ==7">
            <el-option
                v-for="item in theSriMoldAll"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:businessId="{Myformdata}">
        <el-select v-model='Myformdata.businessId' :disabled="Myformdata.sriType!=3">
            <el-option
                v-if="Myformdata.projectId"
                :key="itemOther.businessId"
                :label="itemOther.businessName"
                :value="itemOther.businessId">
            </el-option>
            <el-option
                v-for="item in getProjectBusiness_data.data||[]"
                :key="item.businessId"
                :label="item.businessName"
                :value="item.businessId">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:sriMoney="{Myformdata}">
        <el-input v-model="Myformdata.sriMoney" :disabled="Myformdata.sriMold==2&&Myformdata.sriType!=3" type="number" size="small" placeholder="请输入收益金额"></el-input>
  	  </template>
      <template v-slot:sriMultiply="{Myformdata}">
        <el-input v-model="Myformdata.sriMultiply" :disabled="(Myformdata.sriMold==1&&Myformdata.sriType!=3)||Myformdata.sriType==3" type="number" size="small" placeholder="请输入倍数"></el-input>
  	  </template>
      <template v-slot:sriFrontNum="{Myformdata}">
        <el-input v-model="Myformdata.sriFrontNum" :disabled="Myformdata.sriType!=5&&Myformdata.sriType!=6&&Myformdata.sriType!=8" type="number" size="small" placeholder="请输入前n单"></el-input>
  	  </template>
      <template v-slot:sriMoneyStart="{Myformdata}">
        <el-input v-model="Myformdata.sriMoneyStart" :disabled="Myformdata.sriType!=3&&Myformdata.sriType!=7" type="number" size="small" placeholder="请输入年化金额首"></el-input>
  	  </template>
      <template v-slot:sriMoneyEnd="{Myformdata}">
        <el-input v-model="Myformdata.sriMoneyEnd" :disabled="Myformdata.sriType!=3&&Myformdata.sriType!=7 " type="number" size="small" placeholder="请输入年化金额末"></el-input>
  	  </template>
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemOther:{businessId:0,businessName:"其他业务"},
      theSelectProjectId: "",
      theUserProject: "",
      theSelectSriType: "",
      theSriTypeAll:[
          {id:1,name:"项目首单"},
          {id:2,name:"最大单"},
          {id:3,name:"普通单"},
          {id:4,name:"每日首单"},
          {id:5,name:"项目前n单"},
          {id:6,name:"每日前n单"},
          {id:7,name:"订单总额"},
          {id:8,name:"案例分享"},
      ],
      theSelectSriMold:"",
      theSriMoldAll:[
          {id:1,name:"金额"},
          {id:2,name:"倍数"},
      ],

      tableColums_getSysRuleIncomeList: {
        $selection: false,

        projectName: '项目',

        sriType: ['类型',,'@v-if: 1:项目首单#danger, 2:最大单#danger, 3:普通单, 4:每日首单#danger, 5:项目前n单#danger, 6:每日前n单#danger, 7:订单总额, 8:案例分享'],

        sriMold: ['收益模型',,'@v-if: 1:金额, 2:倍数#danger'],

        sriMoney: '收益金额',

        businessName: '业务名称',

        sriMoney: '收益金额',

        sriMultiply: '倍数',

        sriFrontNum: 'n单',

        sriMoneyStart: '年化金额首',

        sriMoneyEnd: '年化金额尾',

        $operation: [
          '操作', 200,
          this.updateSysRuleIncome && `@text: 编辑#success
           @click: $form("updateSysRuleIncome",$row),getProjectBusiness({projectId:$row.ownership})
          `,
          this.deleteSysRuleIncome && `@text: 删除#danger
           @click: _confirm('确定要删除该收益规则吗?')
                   .trigger('deleteSysRuleIncome',{sriId:$row.sriId})
                   .trigger('getSysRuleIncomeList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    toAddSysRuleIncome(){
      this.$form('addSysRuleIncome');
    },
    sriTypeChange(e){
      this.theSelectSriType=e;
      if(e==3){
        this.Myformdata.sriMold=1;
      }
    },
    sriMoldChange(e){
      this.theSelectSriMold=e;
    },
    theSelectProjectChange(e){
        this.theSelectProjectId=e;
        this.getSysRuleIncomeList({projectId:this.theSelectProjectId});
        this.getProjectBusiness({projectId:e});
    },
    projectChange(e){
        //新增编辑
        this.getProjectBusiness({projectId:e})
    },
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject!=0){
      this.theSelectProjectId=this.theUserProject;
      this.getProjectBusiness({projectId:this.theSelectProjectId});
    }
    this.getSysRuleIncomeList({projectId:this.theSelectProjectId});
    this.getProjectList({ pageSize: 0 });
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/rule/IncomeRuleManage.vue